import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Package } from 'lucide-react';

const WS_COLORS = {
  received: '#3b82f6', in_diagnosis: '#eab308',
  in_repair: '#f97316', ready_for_pickup: '#22c55e',
};

export const meta = {
  id: 'workshop',
  category: 'monitoring',
  titleKey: 'dashboard.widgets.workshop',
  descriptionKey: 'dashboard.widgets.workshopDesc',
  defaultSize: 'lg',
  icon: Package,
};

export default function WorkshopWidget({ ctx }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const workshopSummary = ctx?.workshopSummary || [];
  const wsTotal = workshopSummary.reduce((s, r) => s + (r.count || 0), 0);
  const wsStaleTotal = workshopSummary.reduce((s, r) => s + (r.stale_count || 0), 0);
  const visibleRows = workshopSummary.filter(r => (r.count || 0) > 0);
  if (wsTotal === 0 && wsStaleTotal === 0) return null;

  return (
    <div className="card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => navigate('/tickets?has_hardware=true')}>
      <div className="card-header">
        <div className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Package size={16} />
          {t('serviceOrder.workshopDevices')}
        </div>
        <span style={{ fontSize: 18, fontWeight: 700 }}>{wsTotal}</span>
      </div>
      {visibleRows.length > 0 && (
        <div style={{ padding: '8px 20px 8px', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {visibleRows.map(r => (
            <div
              key={r.hardware_status}
              style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', padding: '4px 8px', borderRadius: 6 }}
              onClick={(e) => { e.stopPropagation(); navigate(`/tickets?has_hardware=true&hardware_status=${r.hardware_status}`); }}
              onMouseEnter={e => (e.currentTarget.style.background = 'var(--c-surface-2)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
            >
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: WS_COLORS[r.hardware_status] || '#6b7280' }} />
              <span style={{ fontSize: 12, color: 'var(--c-text-muted)' }}>{t(`serviceOrder.${r.hardware_status}`)}</span>
              <span style={{ fontSize: 13, fontWeight: 600 }}>{r.count}</span>
            </div>
          ))}
        </div>
      )}
      {wsStaleTotal > 0 && (
        <div
          style={{
            margin: '0 20px 16px', padding: '6px 10px', borderRadius: 6,
            background: 'rgba(249, 115, 22, 0.08)', border: '1px solid rgba(249, 115, 22, 0.25)',
            fontSize: 12, color: 'var(--c-text-muted)',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
          title={t('serviceOrder.staleTooltip')}
        >
          <span style={{ fontWeight: 600, color: '#f97316' }}>⚠ {wsStaleTotal}</span>
          <span>{t('serviceOrder.staleNote')}</span>
        </div>
      )}
    </div>
  );
}
